module.exports = __webpack_public_path__ + "media/images/pc/staffs/qualified-0d15dc16360d0efc4676b8921de119a7.svg";